import React from "react";
import { Box } from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";
import { DataTableLayout } from "./data-table-layout";
var TableSkeleton = function () { return (React.createElement(React.Fragment, null, Array.from({ length: 7 }).map(function (_, index) { return (React.createElement(Box, { mt: 1, key: index },
    React.createElement(Skeleton, { height: 63, variant: "rect" }))); }))); };
export var DataTableSkeleton = function (_a) {
    var header = _a.header;
    return React.createElement(DataTableLayout, { table: React.createElement(TableSkeleton, null), header: header });
};
